import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowLeft, 
  HelpCircle,
  BookOpen,
  FileQuestion,
  ExternalLink,
  Briefcase,
  CreditCard,
  Users,
  Settings
} from 'lucide-react';

function HelpCentre() {
  const helpTopics = [
    {
      title: 'Getting Started',
      icon: BookOpen,
      description: 'Learn the basics of TradeLife',
      articles: [
        'Creating your first job',
        'Setting up integrations',
        'Understanding your dashboard'
      ]
    },
    {
      title: 'Jobs & Quotes',
      icon: Briefcase,
      description: 'Managing your work pipeline',
      articles: [
        'Creating and tracking jobs',
        'Quote to job conversion',
        'Invoice generation'
      ]
    },
    {
      title: 'Finance',
      icon: CreditCard,
      description: 'Financial management tools',
      articles: [
        'Money pots explained',
        'Xero integration setup',
        'Cash flow forecasting'
      ]
    },
    {
      title: 'Team Management',
      icon: Users,
      description: 'Managing your team',
      articles: [
        'Inviting team members',
        'Role permissions',
        'Scheduling tasks'
      ]
    },
    {
      title: 'Account Settings',
      icon: Settings,
      description: 'Configuring your account',
      articles: [
        'Organisation settings',
        'Security & 2FA',
        'Notification preferences'
      ]
    }
  ];

  return (
    <div className="support-page" data-testid="help-centre-page">
      <div className="support-container">
        <Link to="/support" className="support-back-link">
          <ArrowLeft size={16} />
          Back to Support
        </Link>

        <div className="support-header">
          <div className="support-icon">
            <HelpCircle size={28} />
          </div>
          <h1>Help Centre</h1>
          <p className="support-subtitle">
            Find answers to common questions and learn how to use TradeLife
          </p>
        </div>

        {/* Search Placeholder */}
        <div className="help-search" data-testid="help-search">
          <FileQuestion size={20} />
          <input 
            type="text" 
            placeholder="Search help articles..." 
            disabled
            className="help-search-input"
          />
          <span className="help-search-hint">Coming soon</span>
        </div>

        {/* Help Topics */}
        <div className="help-topics" data-testid="help-topics">
          {helpTopics.map((topic, index) => (
            <div key={index} className="help-topic-card">
              <div className="topic-header">
                <div className="topic-icon">
                  <topic.icon size={22} />
                </div>
                <div className="topic-info">
                  <h3>{topic.title}</h3>
                  <p>{topic.description}</p>
                </div>
              </div>
              <ul className="topic-articles">
                {topic.articles.map((article, articleIndex) => (
                  <li key={articleIndex}>
                    <span className="article-link">{article}</span>
                    <ExternalLink size={12} className="article-icon" />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Help Resources */}
        <div className="help-resources">
          <h3>Additional Resources</h3>
          <div className="resource-links">
            <div className="resource-item">
              <BookOpen size={16} />
              <span>Documentation (Coming Soon)</span>
            </div>
            <div className="resource-item">
              <ExternalLink size={16} />
              <span>Video Tutorials (Coming Soon)</span>
            </div>
          </div>
        </div>

        {/* Placeholder Notice */}
        <div className="support-notice">
          <p>
            The Help Centre is being developed. Full documentation and tutorials will be available soon.
          </p>
        </div>
      </div>
    </div>
  );
}

export default HelpCentre;
